module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjY2NjggMS4zMzMzN0w3LjMzMzUgOC42NjY3MSIgc3Ryb2tlPSIjMDA5OUZGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0LjY2NjggMS4zMzMzN0wxMC4wMDAyIDE0LjY2NjdMNy4zMzM1IDguNjY2NzFMMS4zMzM1IDYuMDAwMDRMMTQuNjY2OCAxLjMzMzM3WiIgc3Ryb2tlPSIjMDA5OUZGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./static/website/images/send.svg
// module id = HptP
// module chunks = 1